import { render, staticRenderFns } from "./padination.vue?vue&type=template&id=c7b1e2d8&scoped=true"
import script from "./padination.vue?vue&type=script&lang=js"
export * from "./padination.vue?vue&type=script&lang=js"
import style0 from "./padination.vue?vue&type=style&index=0&id=c7b1e2d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b1e2d8",
  null
  
)

export default component.exports